import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { Button } from '../components/Button';
import { H1 } from '../components/H1';
import { Section } from '../components/Section';
import { TextField } from '../components/TextField';
import { useAuth } from '../hooks';
import { api } from '../plugins/axios';
import { useHistory, useLocation } from 'react-router-dom';

interface FormValues {
  code: string | null;
  password: string;
}

export const ResetPasswordPage = () => {
  const { login } = useAuth();
  const { push } = useHistory();

  const {
    watch,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormValues>();
  const [loading, setLoading] = useState(false);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const code = queryParams.get('code');

  return (
    <Section className="max-w-md">
      <form
        className="space-y-6"
        onSubmit={handleSubmit((data) => {
          data.code = code;
          setLoading(true);
          api
            .post(`/auth/confirm-change-password`, data)
            .then(async () => {
              setLoading(false);
              alert(
                'Your password has been reset successfully. Please log in with your new password.',
              );
              push('/signin');
            })
            .catch((error) => {
              setLoading(false);
              alert(error.response.data.message);
            });
        })}
      >
        <H1>Reset Password</H1>

        <TextField
          type="password"
          label="Password"
          placeholder="********"
          helper={errors.password?.message}
          {...register('password', {
            required: 'This field is required',
            minLength: {
              value: 6,
              message: 'Please enter at least 6 characters',
            },
            maxLength: {
              value: 15,
              message: 'Password length must be 15 or less',
            },
          })}
        />

        <div className="flex flex-col space-y-4 pt-10">
          <Button
            text={loading ? 'Loading...' : 'Confirm Reset Password'}
            className="filled-brand-1"
            disabled={!watch('password') || loading}
          />
        </div>
      </form>
    </Section>
  );
};
